import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';

/**
 * ### **DeleteModalComponent**
 *
 * **Selector:** ``<app-delete-modal>``
 *
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el Componente
 * encargado de renderizar el modal de eliminación.
 */
@Component({
  selector: 'app-delete-modal',
  imports: [MatDialogModule, TranslateModule],
  templateUrl: "./delete-modal.component.html",
  styleUrl: "./delete-modal.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteModal {
  public readonly dialogRef = inject(MatDialogRef<DeleteModal>);
  public readonly data: { mensaje: string } = inject(MAT_DIALOG_DATA);

  /** Variable que guardará el mensaje que se leerá en el modal.*/
  protected readonly mensaje = signal<string>('');

  /**
   * Función nativa de typescript que se encarga de inicializar las variables o llamar metodos
   * para que sean necesarios para el iniciar el componente, en este caso inicializa la variable
   * mensaje con los datos que le llegan por parametro.
   * @param dialogRef Parametro que referencia el componente como un modal.
   * @param data Objeto que recibe los datos que son enviados al modal.
   */
  constructor() {
    this.mensaje.set(this.data.mensaje);
  }

  /** @ignore */
  ngOnInit() {}

  /**
   * Función que se encarga de retornar un valor de tipo booleano para determinar si se elimina o no
   * el elemento, además es el encargado de cerrar el modal.
   * @param response Parametro que recibe como valor un dato de tipo boolean.
   */
  protected close(response: boolean): void {
    this.dialogRef.close({ deleted: response });
  }
}
